/** Absolute path prefix for the V2 bulk rebalance UI. */
export const BULK_REBALANCE_BASE_PATH = '/rebalance';

export const bulkRebalanceDetailPath = (runId: string) =>
  `${BULK_REBALANCE_BASE_PATH}/${runId}`;

const BULK_TRADER_LEGACY_BASE_PATH = '/bulkTrader';

export const getBulkTradeRunDetailPath = (
  bulkTradeRunId: string,
  useBulkTraderRevamp: boolean,
) =>
  `${useBulkTraderRevamp ? '/bulkTraderRevamp' : BULK_TRADER_LEGACY_BASE_PATH}/${bulkTradeRunId}`;
